<script>
import Vue from 'vue';
import Tenant from '~/models/Tenant';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },

    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource.name,
    },

    query: {
      type: Object,
      required: false,
      default: () => new Tenant(),
    },
  },

  methods: {
    fetch() {
      return this.query.$all();
    },
  },
});
</script>
